import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../RushShell/icons';

const matchClass = (m) => {
    if (m >= 90) return '';
    if (m >= 80) return 'm85';
    return 'm70';
};

const MemoryCard = ({ matches = [], term = '', filter = '' }) => (
    <div className="rs-card col-7">
        <div className="rs-card-h">
            <h3>Translation memory</h3>
            <span className="count">{matches.length ? `+${matches.length} matches` : 'No matches'}</span>
            <div className="spacer" />
            <Link className="link" to="/dashboard/glossary">
                Open memory {Icon.arrow}
            </Link>
        </div>
        <div className="mm-search">
            {Icon.search}
            <span>
                Showing matches for <span className="term">&ldquo;{term || 'recent'}&rdquo;</span>
            </span>
            {filter && <span className="filt">{filter}</span>}
        </div>
        <div className="mm-list">
            {matches.length === 0 && (
                <div className="mm-row" style={{ color: 'var(--muted)' }}>
                    <span className="src">No memory matches yet.</span>
                    <span className="tgt">Recent translations will appear here.</span>
                    <span className="match">—</span>
                </div>
            )}
            {matches.slice(0, 5).map((row, i) => (
                <div className="mm-row" key={i}>
                    <span className="src">{row.source}</span>
                    <span className="tgt">{row.target}</span>
                    <span className={`match ${matchClass(row.match)}`}>{row.match}%</span>
                </div>
            ))}
        </div>
    </div>
);

export default MemoryCard;
